import { PURCHASING_GROUP as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    refreshBtn: false,
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'center',
    menu: false,
    border: true,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    labelPosition: 'top',
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      {
        searchLabelWidth: 120,
        label: LABELS.purchasingGroupCode,
        prop: 'orgId',
        overHidden: true,
        search: true
      },
      {
        label: LABELS.description,
        prop: 'orgDesc',
        overHidden: true,
        search: true
      }
    ]
  }
};
